exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".block[data-v-86160b62]{padding:20px}.description[data-v-86160b62]{color:#000;font-size:16px}", ""]);

// exports
